<manage-wrapper
  *ngIf="!!attendee && { brief: attendeeBriefs[attendee?.id] } as a"
  [canEditMain]="!readOnly"
  [topToggleText]="'ATTENDEE ' + (attendee.confirmed ? '' : 'NOT ' ) + 'CONFIRMED'"
  [topToggled]="!!attendee.confirmed"
  [entityTitle]="attendee.name || ''"
  [tabGroups]="tabGroups"
  [selectedTab]="selectedTab"
  [readOnly]="readOnly"
  [labels]="attendee.labels || []"
  [labelMap]="labelMap"
  [labelList]="labels"
  [clipLabel]="readOnly ? '' : clipLabel"
  [deleteTitle]="'Delete attendee: ' + (attendee.name || 'Unnamed attendee')"
  [labelUpdateFunction]="labelUpdateFunction.bind(this)"
  [titlePlaceholder]="'Attendee name...'"
  [backgroundColor]="'#41474F'"
  [dialogTitle]="'Manage Attendee'"
  [type]="'attendee'"
  [showStars]="true"
  [stars]="attendee.stars || 0"
  (saveStars)="saveStars($event)"
  (onToggle)="toggleAttendeeConfirmed()"
  (onDone)="exit()"
  (onChangeTab)="changeTab($event)"
  (onDelete)="deleteAttendee()"
  (onDuplicate)="duplicateAttendee()"
  (saveTitle)="updateAttendeeName($event)"
  (onClip)="clip()"
>

  <entity-types class="afterTitle"
    [readOnly]="readOnly"
    [entityType]="'attendee'"
    [entity]="attendee"
  ></entity-types>
  
  <ng-container *ngIf="selectedTab?.id === tabs.sessions">  
    <add-manage-wrapper [hideHRule]="true" class="session-list" [openLabel]="sessionProgramList.length && !data.readOnly ? '+ ADD TO A SESSION' : ''" (open)="sessionProgramList.length ? addToASession($event) : null">
      <div class="session-message">
        <div *ngIf="!sessionList.length" class="empty-text">This attendee is not tagged on any sessions.</div>
      </div>
  
      <status-wrapper *ngFor="let session of sessionList"
        class="sessions"
        [ngClass]="{ clickable: !data.readOnly }"
        (click)="data.readOnly ? null : manageSession(session)"
        [deleteTitle]="'Untag ' + attendee.name + ' from this session'"
        [wideFormat]="true"
        [hideStatus]="true"
        [readOnly]="data.readOnly"
        [threeDotOptions]="threeDotSessionOptions"
        (threeDotSelection)="sessionDotMenuSelection($event, session)"
      >
        <big-and-grey class="wideContent" [theTitle]="session.title" greyText="{{ session.start }} - {{ session.end }}, {{ (session.day ? session.day : session.date | date: 'd MMMM y') }}" ></big-and-grey>
      </status-wrapper>
    </add-manage-wrapper>
  
  </ng-container>

  <ng-container *ngIf="!selectedTab || selectedTab?.id === tabs.info">
    <ng-container *ngIf="!readOnly">
      <tip-text class="ex-profile" *ngIf="attendeeShareable?.status == 'Active'" [type]="'warn'" [head]="'Attention:'" [body]="'This attendee has an active webform to edit profile information.'"></tip-text>
      <tip-text class="ex-profile" *ngIf="!attendeeShareable || attendeeShareable.status != 'Active'" [type]="'tip'" [head]="'Tip:'" [body]="'Attendees can submit their profile information using a shareable link by turning on the <strong>Profile webform for editing</strong> below.'"></tip-text>
    </ng-container>
    <ng-container *ngIf="!readOnly">
      <div>Share webform to receive attendee profile information.</div>
      <binary-share-toggle
        [type]="'profile'"
        [shareType]="shareTypes.attendee"
        [hideBottom]="!attendeeShareable"
        [shareableFormat]="'oneLine'"
        [shareCode]="attendeeShareable?.code"
        [hint]="'Note: Once a submission is made the status will change from “Active” to “Submitted” and the link will be closed. To re-enable the link, change the status back to “Active”.'"
        [title]="'Profile webform'"
        [shareTitle]="'Your shareable webform:'"
        [generatingCode]="generatingEditCode"
        [status]="attendeeShareable?.status || 'Off'"
        (toggle)="toggleAttendeeProfile()"
        (changeStatus)="changeAttendeeProfileStatus($event)"
      ></binary-share-toggle>
    </ng-container>

    <image-uploader 
      [id]="attendee.id"
      (newUrls)="changeImage($event)"
      [immediate]="true" 
      [isLogo]="true"
      [displayType]="imageUploaderDisplayTypes.widePodLogo"
      [thumbUrl]="attendee.photoUrl" 
      [photoUrl]="attendee.fullPhotoUrl"
      [eventId]="event?.eventId"
      [type]="'attendee'" 
      [subtype]="'photo'" 
      [placeholder]="'Add photo'" 
      [uploadText]="'UPLOAD PHOTO'"
      [saveName]="attendee.name"
    ></image-uploader>

    <h3 class="description-title">Line 1 (e.g. job title)</h3>
    <joi-input class="description" [disabled]="data.readOnly" [italicPlaceholder]="true" [(model)]="attendee.line1" [placeholder]="'Click to add line 1...'" (joiChange)="saveAttendee()"></joi-input>

    <h3 class="description-title">Line 2 (e.g. company)</h3>
    <joi-input class="description" [disabled]="data.readOnly" [italicPlaceholder]="true" [(model)]="attendee.line2" [placeholder]="'Click to add line 2...'" (joiChange)="saveAttendee()"></joi-input>

    <manage-social [links]="attendee?.social" (saveLinks)="saveSocialLinks($event)"></manage-social>
    <hr class="big-rule"/>

    <manage-contact-details
      [entity]="attendee"
      [entityName]="'Attendee'"
      [numberProp]="'phone'"
      [emailProp]="'email'"
      [readOnly]="readOnly"
      (contactDetailsChanged)="saveAttendee()"
    ></manage-contact-details>

    <custom-questions-app
      [entity]="attendee"
      [entityType]="'attendee'"
      (updateQuestion)="updateCustomQuestion($event)"
    ></custom-questions-app>

  </ng-container>

  <ng-container *ngIf="selectedTab?.id === tabs.contact">
    <tip-text class="top" [type]="'tip'" [head]="'Tip:'" [body]="'The workforce contact will appear in the attendee brief.'"></tip-text>
    <manage-contact
      [workforceContactEmail]="attendee?.WFContact"
      [readOnly]="readOnly"
      (changeContact)="changeWorkforceContact($event)"
    ></manage-contact>
  </ng-container>


  <ng-container *ngIf="selectedTab?.id === tabs.quickNotes">
    <chat-box [isNotes]="true" [comments]="attendee?.quickNotes || []" [readOnly]="!event || event.is_readonly" (quickNotesChanged)="saveQuickNotes($event)" ></chat-box>
  </ng-container>

  <entity-tasks *ngIf="selectedTab?.id === tabs.tasks" [entity]="attendee" [changeDetectorRef]="changeDetectorRef"></entity-tasks>

  <ng-container *ngIf="selectedTab?.id === tabs.briefInfo">
    <tip-text class="top" [head]="'Tip:'" [body]="'Information added here will only appear in <strong>'+attendee.name+'&rsquo;s</strong> attendee brief.'"></tip-text>
    <title-icon [titleIcon]="'description18'" [title]="'Information for '+attendee.name+' only'"></title-icon>
    <div class="empty-text">Add information or instructions specific to this attendee</div>
    <informable 
      [singleSectionOnly]="true"
      [informableType]="'attendee'" 
      [informableKey]="data.attendeeId" 
      [noItemsMessage]="''"
      ></informable>
  </ng-container>

  <ng-container *ngIf="selectedTab?.id === tabs.configBrief">
    <h3 style="padding: 20px 0 ; ">Configure actions to include in {{ attendee.name }}'s attendee brief</h3>
    <tip-text class="top" [type]="'important'" [head]="'Important'" [body]="'Actions will automatically appear in '+ attendee.name +'\'s Exhibitor Brief when the below configurations are set to &ldquo;ON&rdquo;'"></tip-text>
    <h5>PROFILE</h5>
    <add-link-to-brief-wrapper
      style="margin-top: 10px; display: block;"
      [title]="'<strong>Include profile webform</strong>'"
      [toggleOn] = "attendee.showEditProfileLinkInBrief"
      [selected] = "attendeeShareable?.status || 'Off'"
      (toggle)="updateShowEditProfileLinkInBrief()"
      (toggleStatus)="changeAttendeeProfileStatus($event)"
    ></add-link-to-brief-wrapper>
 
    <manage-terms [type]="'attendee'" [entity]="attendee" [readOnly]="readOnly" (saveEntity)="saveAttendee()"></manage-terms>
  </ng-container>

  <ng-container *ngIf="selectedTab?.id === tabs.schedule">
    <app-brief *ngIf="!!event && !!attendee"
      [attendee]="attendee"
      [briefType]="'attendee'"
      [briefInfo]="a.brief"
      [timelineOnly]="true"
    ></app-brief>
  </ng-container>

  <ng-container *ngIf="selectedTab?.id === tabs.preview">
      <binary-share-toggle
        class="brief"
        [type]="'brief'"
        [contactName]="attendee.name || ''"
        [contactEmail]="attendee.email || ''"
        [shareType]="shareTypes.attendeeBrief"
        [shareableFormat]="'oneLine'"
        [shareCode]="a.brief?.id"
        [hint]="'Note: The shareable webpage below is dynamic and will always load the current information for the attendee.'"
        [title]="'Attendee Brief webpage'"
        [shareTitle]="'Your shareable webpage:'"
        [status]="a.brief?.status || 'Off'"
        [alwaysOnMessage]="'Share the attendee brief as a webpage.'"
        (toggle)="shareUrl($event)"
        (changeStatus)="shareUrl($event === 'Off' ? false : true)"
      ></binary-share-toggle>
      <tip-text class="top" class="brief-tip bottom" [type]="'tip'" [head]="'Tip:'" [body]="'Below is what <strong>' + attendee.name + '</strong> will see when they view their brief.\n\nAn attendee’s brief is built automatically from other sections of Joi — for example, you can include a program in the <strong>Set Up</strong> section.'"></tip-text>
  
      <hr class="big-rule" />
      <app-brief *ngIf="!!event && !!attendee"
        [attendee]="attendee"
        [briefType]="'attendee'"
        [briefInfo]="a.brief"
      ></app-brief>
  </ng-container>
</manage-wrapper>



